module.exports = __webpack_public_path__ + "static/media/impress.a467ee48.png";